// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { NavigateNextRounded } from '@/constants/hardfin-standard-icons';
import { Button, Paper, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from '@tanstack/react-router';

/** Sends somebody from their account to where their notifications are set. */
export function NotificationSettingsCard() {
  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <Stack
        useFlexGap
        spacing={1}
        paddingX={2}
        paddingY={2}
        direction="row"
        alignItems="center"
      >
        <Typography variant="overline" marginRight="auto">
          Notifications
        </Typography>
        <Button
          component={RouterLink}
          to="/notifications/subscriptions"
          size="small"
          endIcon={<NavigateNextRounded fontSize="small" />}
        >
          Manage notification subscriptions
        </Button>
      </Stack>
    </Paper>
  );
}
